import React, { Component } from "react";
//import styled, { keyframes } from 'styled components';
import PropTypes from 'prop-types';


import gelFlat from "../../img/rotor-adapters.svg";
import gelFlipped from "../../img/rotor-adapters.svg";

const images = {
  gelFlipped: gelFlipped,
  gelFlat: gelFlat
};

export class Graphics extends Component {
  componentWillMount() {
    for (var image in images) {
      if (!image.replace(this.props.type, "").includes(0)) {
        const img = new Image();
        img.src = images[image];
      }
    }
  }

  getImage = () => {
    let reference = "gel";

    if (this.props.held) {
      reference += "Flipped";
    } else if (!this.props.onShelf){
      reference += "Flipped";
    } else if(this.props.materialsView){
      reference += "Flipped";
    } else {
      reference += "Flipped";
    }

    return images[reference];
  };

  render (){
    return(
      <img
      width="25"
      aria-label="Rotor Adapters"
      alt="Rotor Adapters"
      aria-hidden={this.props.context==="Materials"?"true":"false"}
      className={this.props.type+"-gel gel"}
      src={this.getImage()}/>
    )
  }
}
Graphics.propTypes = {
  setRotorAdaptersHeld: PropTypes.func,
}

Graphics.defaultProps = {

}

